export default "__VITE_ASSET__CEWsFW0m__"